import coursePlayer from "./coursePlayer";

export default [coursePlayer];